import script from "./QrCodeDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./QrCodeDialog.vue?vue&type=script&lang=ts&setup=true"

import "./QrCodeDialog.vue?vue&type=style&index=0&id=08b2c3c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08b2c3c7"]])

export default __exports__